export var databaseName = 'office-start-simple-persistence';
export var storeName = 'items';
//# sourceMappingURL=Constants.js.map